import {UpwardProxy} from "@Common/react/upward-proxy";

export const Trimmer = ({state, next}) => UpwardProxy({
    mod: (s) => s?.trim(),
    state,
    next,
});
